<template>
    <div style="padding: 100px; position: center;  text-align: right; color: #dddd; ">

    </div>

</template>
<script>
    import {myScore} from "../../assets/js/api.js";
    import store from 'store'

    export default {
        data() {
            return {
                currentTab: "知识分享",
                lists: [],
                list: [],
                downloadLoading: false,
                listLoading: true,
                multipleSelection: [],
                tableData: [],
                tableHeader: [],

            };
        },
        // mounted() {
        //   this.getScore()
        // },
        created() {
            this.getScore()
        },
        methods: {}
    };
</script>

